import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "rw",
  "aria-label": "Product opportunities and feedback"
}
const _hoisted_2 = {
  class: "workspace-tabs",
  "aria-label": "Workspace sections"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_6 = {
  key: 1,
  class: "notice",
  role: "status"
}
const _hoisted_7 = {
  key: 2,
  role: "status"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "section-intro" }
const _hoisted_10 = {
  key: 0,
  class: "empty"
}
const _hoisted_11 = { class: "opportunity-grid" }
const _hoisted_12 = { class: "card-meta" }
const _hoisted_13 = { class: "chip" }
const _hoisted_14 = {
  key: 0,
  class: "chip audience"
}
const _hoisted_15 = {
  key: 1,
  class: "chip phase"
}
const _hoisted_16 = { class: "effort" }
const _hoisted_17 = {
  key: 0,
  class: "score-line",
  title: 'Priority = reach × impact × confidence ÷ effort'
}
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "proposal" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "value" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "value demand"
}
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "review-date" }
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  key: 2,
  class: "card-changed",
  role: "note"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "snapshot" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "review-date" }
const _hoisted_37 = ["disabled", "onClick"]
const _hoisted_38 = {
  key: 3,
  class: "version-note"
}
const _hoisted_39 = ["disabled", "onClick"]
const _hoisted_40 = {
  key: 4,
  class: "version-note warn",
  role: "alert"
}
const _hoisted_41 = ["aria-pressed", "onClick"]
const _hoisted_42 = ["aria-label", "onUpdate:modelValue", "onInput"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 1,
  class: "decision-footer"
}
const _hoisted_45 = ["disabled"]
const _hoisted_46 = {
  key: 1,
  class: "chat-area"
}
const _hoisted_47 = { class: "chat-heading" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = {
  key: 0,
  class: "history-select"
}
const _hoisted_50 = ["value", "disabled"]
const _hoisted_51 = ["value"]
const _hoisted_52 = {
  class: "messages",
  "aria-live": "polite",
  "aria-relevant": "additions text"
}
const _hoisted_53 = {
  key: 0,
  class: "chat-welcome"
}
const _hoisted_54 = { class: "bubble user" }
const _hoisted_55 = { class: "bubble assistant" }
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = {
  key: 1,
  class: "error"
}
const _hoisted_58 = {
  key: 2,
  class: "thinking"
}
const _hoisted_59 = {
  key: 3,
  class: "source-note"
}
const _hoisted_60 = { class: "composer" }
const _hoisted_61 = { class: "composer-actions" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = { class: "submit-callout" }
const _hoisted_64 = ["disabled"]
const _hoisted_65 = ["disabled"]
const _hoisted_66 = {
  key: 2,
  class: "requests"
}
const _hoisted_67 = { class: "section-intro" }
const _hoisted_68 = {
  key: 0,
  class: "empty"
}
const _hoisted_69 = { class: "request-top" }
const _hoisted_70 = { class: "request-date" }
const _hoisted_71 = { class: "request-body" }
const _hoisted_72 = {
  key: 0,
  class: "mail-note"
}
const _hoisted_73 = {
  key: 1,
  class: "mail-note"
}
const _hoisted_74 = { class: "timeline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoiceDictation = _resolveComponent("VoiceDictation")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "rw-heading" }, [
      _createElementVNode("div", null, [
        _createElementVNode("span", { class: "eyebrow" }, "Shape what comes next"),
        _createElementVNode("h1", null, "Make IronBook work better for you."),
        _createElementVNode("p", null, "Choose the ideas that matter. Or tell us what you have in mind.")
      ]),
      _createElementVNode("span", { class: "private-badge" }, "Superadmin workspace")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (t) => {
        return (_openBlock(), _createElementBlock("button", {
          key: t.id,
          class: _normalizeClass({selected:_ctx.tab===t.id}),
          onClick: ($event: any) => (_ctx.tab=t.id)
        }, [
          _createTextVNode(_toDisplayString(t.label) + " ", 1),
          (t.id==='requests')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.requests.length), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
          _createTextVNode(_toDisplayString(_ctx.error) + " ", 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
          }, "Try again")
        ]))
      : _createCommentVNode("", true),
    (_ctx.notice)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.notice), 1))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Loading your workspace…"))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          (_ctx.tab==='ideas')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                    _createElementVNode("h3", null, "What should we build next?"),
                    _createElementVNode("p", null, "Research-backed improvements, ordered by suggested priority. Your choices stay saved between reports.")
                  ], -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.selectedCount) + " reviewed", 1)
                ]),
                (!_ctx.opportunities.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, "New opportunities will appear here after the next research update. You can still share an idea in the chat."))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.opportunities, (o) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: o.id,
                      class: _normalizeClass(["opportunity", {'chosen':_ctx.choices[o.id]?.choice==='yes','needs-review':o.card_status==='changed'}])
                    }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(o.data.category), 1),
                        (o.data.audience)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(o.data.audience), 1))
                          : _createCommentVNode("", true),
                        (o.data.phase)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(o.data.phase), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_16, _toDisplayString(o.data.effort) + " effort", 1)
                      ]),
                      _createElementVNode("h4", null, _toDisplayString(o.data.title), 1),
                      (o.data.score)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.scoreLine(o.data.score)), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("p", {
                        innerHTML: _ctx.md(o.data.problem)
                      }, null, 8, _hoisted_18),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[16] || (_cache[16] = _createElementVNode("b", null, "The opportunity", -1)),
                        _createElementVNode("p", {
                          innerHTML: _ctx.md(o.data.proposal)
                        }, null, 8, _hoisted_20)
                      ]),
                      _createElementVNode("p", _hoisted_21, [
                        _cache[17] || (_cache[17] = _createElementVNode("b", null, "Why it matters", -1)),
                        _cache[18] || (_cache[18] = _createTextVNode()),
                        _createElementVNode("span", {
                          innerHTML: _ctx.md(o.data.value)
                        }, null, 8, _hoisted_22)
                      ]),
                      (o.data.demand)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                            _cache[19] || (_cache[19] = _createElementVNode("b", null, "Buyer demand", -1)),
                            _cache[20] || (_cache[20] = _createTextVNode()),
                            _createElementVNode("span", {
                              innerHTML: _ctx.md(o.data.demand)
                            }, null, 8, _hoisted_24)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("details", null, [
                        _cache[21] || (_cache[21] = _createElementVNode("summary", null, "Research & what exists today", -1)),
                        _createElementVNode("p", {
                          innerHTML: _ctx.md(o.data.current)
                        }, null, 8, _hoisted_25),
                        _createElementVNode("p", {
                          innerHTML: _ctx.md(o.data.evidence)
                        }, null, 8, _hoisted_26),
                        _createElementVNode("p", _hoisted_27, "Reviewed " + _toDisplayString(o.data.checkedAt) + " · Source " + _toDisplayString(o.data.commit?.slice(0,7)), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(o.data.sources, (s) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: s.url,
                            href: _ctx.safeUrl(s.url),
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, _toDisplayString(s.title) + " ↗", 9, _hoisted_28))
                        }), 128))
                      ]),
                      (o.card_status==='changed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _cache[27] || (_cache[27] = _createElementVNode("b", null, "Card changed since you answered — review", -1)),
                            _createElementVNode("p", null, "You answered “" + _toDisplayString(_ctx.choiceLabel(o.choice)) + "” on " + _toDisplayString(_ctx.date(o.decided_at)) + ". This idea has been rewritten since, so your answer may not fit the text above.", 1),
                            (o.decision_card_snapshot)
                              ? (_openBlock(), _createElementBlock("details", _hoisted_30, [
                                  _cache[26] || (_cache[26] = _createElementVNode("summary", null, "What it said when you answered", -1)),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("p", null, [
                                      _createElementVNode("b", null, _toDisplayString(o.decision_card_snapshot.title), 1)
                                    ]),
                                    (o.decision_card_snapshot.problem)
                                      ? (_openBlock(), _createElementBlock("p", {
                                          key: 0,
                                          innerHTML: _ctx.md(o.decision_card_snapshot.problem)
                                        }, null, 8, _hoisted_32))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("p", null, [
                                      _cache[22] || (_cache[22] = _createElementVNode("b", null, "The opportunity:", -1)),
                                      _cache[23] || (_cache[23] = _createTextVNode()),
                                      _createElementVNode("span", {
                                        innerHTML: _ctx.md(o.decision_card_snapshot.proposal||'')
                                      }, null, 8, _hoisted_33)
                                    ]),
                                    (o.decision_card_snapshot.value)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                                          _cache[24] || (_cache[24] = _createElementVNode("b", null, "Why it matters:", -1)),
                                          _cache[25] || (_cache[25] = _createTextVNode()),
                                          _createElementVNode("span", {
                                            innerHTML: _ctx.md(o.decision_card_snapshot.value)
                                          }, null, 8, _hoisted_35)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("p", _hoisted_36, [
                                      _createTextVNode(_toDisplayString(o.decision_card_snapshot.effort) + " effort", 1),
                                      (o.decision_card_snapshot.audience)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(" · " + _toDisplayString(o.decision_card_snapshot.audience), 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (o.decision_card_snapshot.score)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode(" · " + _toDisplayString(_ctx.scoreLine(o.decision_card_snapshot.score)), 1)
                                          ], 64))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "secondary",
                              disabled: _ctx.saving,
                              onClick: ($event: any) => (_ctx.reconfirm(o))
                            }, "Confirm “" + _toDisplayString(_ctx.choiceLabel(_ctx.choices[o.id]?.choice||o.choice)) + "” for this version", 9, _hoisted_37)
                          ]))
                        : (o.card_status==='unversioned')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_38, [
                              _cache[28] || (_cache[28] = _createTextVNode("Answered before card versions were tracked. ", -1)),
                              _createElementVNode("button", {
                                class: "text-button",
                                disabled: _ctx.saving,
                                onClick: ($event: any) => (_ctx.reconfirm(o))
                              }, "Confirm for this version", 8, _hoisted_39)
                            ]))
                          : _createCommentVNode("", true),
                      (_ctx.editConflict[o.id])
                        ? (_openBlock(), _createElementBlock("p", _hoisted_40, "This card was updated while you were editing. Review it, then submit again."))
                        : _createCommentVNode("", true),
                      _createElementVNode("fieldset", null, [
                        _cache[29] || (_cache[29] = _createElementVNode("legend", null, "Would this help your team?", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.choicesList, (c) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: c.id,
                            "aria-pressed": _ctx.choices[o.id]?.choice===c.id,
                            class: _normalizeClass(['choice',c.id,{active:_ctx.choices[o.id]?.choice===c.id}]),
                            onClick: ($event: any) => (_ctx.choose(o,c.id))
                          }, _toDisplayString(c.label), 11, _hoisted_41))
                        }), 128))
                      ]),
                      _withDirectives(_createElementVNode("textarea", {
                        "aria-label": 'Feedback on '+o.data.title,
                        placeholder: "Anything you would change? (optional)",
                        maxlength: "5000",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.choices[o.id].note) = $event),
                        onInput: ($event: any) => (_ctx.markDirty(o))
                      }, null, 40, _hoisted_42), [
                        [_vModelText, _ctx.choices[o.id].note]
                      ]),
                      _createElementVNode("button", {
                        class: "text-button",
                        onClick: ($event: any) => (_ctx.discuss(o))
                      }, "Talk through this idea →", 8, _hoisted_43)
                    ], 2))
                  }), 128))
                ]),
                (_ctx.opportunities.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _cache[30] || (_cache[30] = _createElementVNode("p", null, "“Yes” adds a development request. Changing a choice later saves your feedback; it does not cancel a submitted request.", -1)),
                      _createElementVNode("button", {
                        class: "primary",
                        disabled: _ctx.saving||!_ctx.pendingIDs.length,
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveDecisions && _ctx.saveDecisions(...args)))
                      }, _toDisplayString(_ctx.saving?'Saving…':_ctx.pendingIDs.length?'Submit choices':'Choices saved'), 9, _hoisted_45)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.tab==='chat')
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", null, [
                    _createElementVNode("h3", null, "Talk it through"),
                    _createElementVNode("p", null, "Discuss an idea with an assistant that can look up how IronBook works.")
                  ], -1)),
                  _createElementVNode("button", {
                    class: "secondary",
                    disabled: _ctx.voiceBusy,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.newChat && _ctx.newChat(...args)))
                  }, "New conversation", 8, _hoisted_48)
                ]),
                (_ctx.threads.length)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_49, [
                      _cache[33] || (_cache[33] = _createTextVNode("Previous conversations", -1)),
                      _createElementVNode("select", {
                        value: _ctx.threadID,
                        disabled: _ctx.voiceBusy,
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openThread(($event.target as HTMLSelectElement).value)))
                      }, [
                        _cache[32] || (_cache[32] = _createElementVNode("option", { value: "" }, "Choose a conversation", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.threads, (t) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: t.id,
                            value: t.id
                          }, _toDisplayString(t.title), 9, _hoisted_51))
                        }), 128))
                      ], 40, _hoisted_50)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_52, [
                  (!_ctx.messages.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [...(_cache[34] || (_cache[34] = [
                        _createElementVNode("span", { class: "spark" }, "✦", -1),
                        _createElementVNode("h4", null, "What would you like to improve?", -1),
                        _createElementVNode("p", null, "Describe a problem, explore one of the research ideas, or ask whether something is already possible.", -1),
                        _createElementVNode("small", null, "We’ll save a request only when you choose Submit request.", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (m) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: m.id,
                      class: "exchange"
                    }, [
                      _createElementVNode("div", _hoisted_54, [
                        _cache[35] || (_cache[35] = _createElementVNode("small", null, "You", -1)),
                        _createElementVNode("p", null, _toDisplayString(m.message), 1)
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _cache[36] || (_cache[36] = _createElementVNode("small", null, "IronBook assistant", -1)),
                        (m.reply)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              innerHTML: _ctx.renderReply(m.reply)
                            }, null, 8, _hoisted_56))
                          : (m.status==='failed')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_57, "The assistant couldn’t finish this reply. You can send your question again or submit a request directly."))
                            : (_openBlock(), _createElementBlock("p", _hoisted_58, "Looking into it…")),
                        (m.source_commit)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_59, "Reviewed source " + _toDisplayString(m.source_commit.slice(0,7)) + " · read-only", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _cache[37] || (_cache[37] = _createElementVNode("label", { for: "research-message" }, "Your message", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "research-message",
                    ref: "messageInput",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.message) = $event)),
                    maxlength: "6000",
                    placeholder: "Type an idea, or tap the microphone and talk…",
                    onKeydown: [
                      _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["ctrl","prevent"]), ["enter"])),
                      _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["meta","prevent"]), ["enter"]))
                    ]
                  }, null, 544), [
                    [_vModelText, _ctx.message]
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _createVNode(_component_VoiceDictation, {
                      "api-url": _ctx.apiUrl,
                      onText: _ctx.insertDictation,
                      onBusy: _cache[7] || (_cache[7] = ($event: any) => (_ctx.voiceBusy=$event))
                    }, null, 8, ["api-url", "onText"]),
                    _createElementVNode("button", {
                      class: "primary",
                      disabled: _ctx.sending||_ctx.chatPending||_ctx.voiceBusy||!_ctx.message.trim(),
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
                    }, _toDisplayString(_ctx.sending?'Saving…':_ctx.chatPending?'Waiting for reply…':'Send message →'), 9, _hoisted_62)
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _cache[38] || (_cache[38] = _createElementVNode("div", null, [
                    _createElementVNode("b", null, "Ready to hand this over?"),
                    _createElementVNode("p", null, "Review the title and details, then send a development request to Nate.")
                  ], -1)),
                  _createElementVNode("button", {
                    class: "secondary",
                    disabled: _ctx.voiceBusy,
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.prepareRequest && _ctx.prepareRequest(...args)))
                  }, "Prepare request", 8, _hoisted_64)
                ]),
                (_ctx.requestForm)
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 1,
                      class: "request-form",
                      onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitRequest && _ctx.submitRequest(...args)), ["prevent"]))
                    }, [
                      _cache[41] || (_cache[41] = _createElementVNode("h4", null, "Review your request", -1)),
                      _createElementVNode("label", null, [
                        _cache[39] || (_cache[39] = _createTextVNode("Title", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestTitle) = $event)),
                          maxlength: "180",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.requestTitle]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[40] || (_cache[40] = _createTextVNode("What would you like changed?", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestBody) = $event)),
                          maxlength: "10000",
                          required: ""
                        }, null, 512), [
                          [_vModelText, _ctx.requestBody]
                        ])
                      ]),
                      _createElementVNode("p", null, _toDisplayString(_ctx.notificationsEnabled?"Submitting saves this request to your history and queues an email to Nate.":"Submitting saves this request to your history. Email delivery is off on this preview."), 1),
                      _createElementVNode("div", null, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "secondary",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.requestForm=false))
                        }, "Keep chatting"),
                        _createElementVNode("button", {
                          class: "primary",
                          disabled: _ctx.saving||!_ctx.requestTitle.trim()||!_ctx.requestBody.trim()
                        }, _toDisplayString(_ctx.saving?'Submitting…':'Submit request'), 9, _hoisted_65)
                      ])
                    ], 32))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.tab==='requests')
            ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _cache[42] || (_cache[42] = _createElementVNode("div", null, [
                    _createElementVNode("h3", null, "My requests"),
                    _createElementVNode("p", null, "Your submissions and the latest development updates.")
                  ], -1)),
                  _createElementVNode("button", {
                    class: "secondary",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
                  }, "Refresh")
                ]),
                (!_ctx.requests.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_68, "No requests submitted yet. Choose an opportunity or tell us your idea."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requests, (r) => {
                  return (_openBlock(), _createElementBlock("article", {
                    key: r.id,
                    class: "request-card"
                  }, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("h4", null, _toDisplayString(r.title), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(['status',r.status])
                      }, _toDisplayString(_ctx.statusLabel[r.status]||r.status), 3)
                    ]),
                    _createElementVNode("p", _hoisted_70, "Submitted " + _toDisplayString(_ctx.date(r.created_at)) + " · " + _toDisplayString(r.id.slice(0,8)), 1),
                    _createElementVNode("p", _hoisted_71, _toDisplayString(r.body), 1),
                    (r.card_status==='changed')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_72, "This idea’s card has been rewritten since you submitted. Your request keeps the version you approved."))
                      : _createCommentVNode("", true),
                    (r.notification_status!=='sent')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(_ctx.notificationsEnabled?"Saved. Email notification is pending.":"Saved. Email delivery is off on this preview."), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("ol", _hoisted_74, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.events, (e) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: e.id
                        }, [
                          _createElementVNode("b", null, _toDisplayString(_ctx.statusLabel[e.status]||e.status), 1),
                          _createElementVNode("span", null, _toDisplayString(e.note), 1),
                          _createElementVNode("small", null, _toDisplayString(_ctx.date(e.created_at)), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}